<template>
  <div class="container mx-auto">
    <div class="mx-4 py-5">
      <doe-button
        prefix="chevronLeft"
        size="small"
        textAlignment="left"
        @click="handleBack()"
      >
        {{ label }}
      </doe-button>
    </div>
  </div>
</template>

<script>
import DoeButton from "@/components/button/Button";

export default {
  name: "NavigationBack",
  props: {
    label: {
      type: String,
      default: "Back"
    },
    route: {
      type: String
    }
  },
  components: {
    DoeButton
  },
  methods: {
    handleBack() {
      if (this.route) {
        this.$router.push({ name: this.route });
      } else {
        this.$router.go(-1);
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
